// 空闲教室
import restRooms from "@/components/newPages/student/restRooms/index";
import roomMore from "@/components/newPages/student/restRooms/roomMore";
import toBorrow from "@/components/newPages/student/restRooms/borrowViwe";
import borrowBar from "@/components/newPages/student/restRooms/borrowBar";
import borrowRulst from "@/components/newPages/student/restRooms/borrwRulst";
import borrowList from "@/components/newPages/teacher/roomBorrow/borrowList";
// 南京林业空闲教室
import njkxRooms from "@/components/newPages/student/njkxRooms/searTable";
// 培养方案
import trainIndex from "@/components/newPages/student/train/index";
import trainItem from "@/components/newPages/student/train/item";
// 辅修报名
import fxApplyIndex from "@/components/newPages/student/fxApply/index";
//学生过程评价
import processEvaluationIndex from "@/components/newPages/student/processEvaluation/index";
//学生评价
import studentEvaluationIndex from "@/components/newPages/student/studentEvaluation/index";
//学生留言
import dialogueIndex from "@/components/newPages/student/dialogue/index";
// 重修报名
import cxApplyIndex from "@/components/newPages/student/cxApply/index";
import cxApplyIndex_12959 from "@/components/newPages/student/cxApply/index_12959";
// 补考报名
import bkApplyIndex from "@/components/newPages/student/bkApply/index";
// 教学课堂反馈
import teachIndex from "@/components/newPages/student/classTeachAdvice/index";
import teachMore from "@/components/newPages/student/classTeachAdvice/more";
import teachContent from "@/components/newPages/student/classTeachAdvice/content";
// 学生教室借用
import roomBorrowIndex from "@/components/newPages/student/roomBorrow/index";
// 创新学分查看
import cxxfIndex from "@/components/newPages/student/cxxf/index";
import xywcqkIndex from "@/components/newPages/student/xywcqk/index";
// 北科学生评教
import xspjIndex from "@/components/newPages/student/bkEvaluate/index";
import xspjItem from "@/components/newPages/student/bkEvaluate/item";
import xspjPJ from "@/components/newPages/student/bkEvaluate/pj";
// 实习任务
import sxTask from "@/components/newPages/student/sxTask/index";
import sxTaskItem from "@/components/newPages/student/sxTask/item";
// 实习考勤
import sxKq from "@/components/newPages/student/sxKq/index";
import sxKqItem from "@/components/newPages/student/sxKq/item";
import sxKqKQ from "@/components/newPages/student/sxKq/KaoQing";
import sxKqTime from "@/components/newPages/student/sxKq/time";
import sxKqDaka from "@/components/newPages/student/sxKq/daka";
// 单独实习申请
import sxAlone from "@/components/newPages/student/sxAlone/index";
import sxAloneApply from "@/components/newPages/student/sxAlone/apply";
// 实习异动
import sxChange from "@/components/newPages/student/sxChange/index";
import sxChangeApply from "@/components/newPages/student/sxChange/apply";
import sxChangeItem from "@/components/newPages/student/sxChange/item";
// 查询申请
import selectApplyIndex from "@/components/newPages/student/selectApply/index";
import selectApplyList from "@/components/newPages/student/selectApply/chooseList";
import selectApplyApply from "@/components/newPages/student/selectApply/apply";
// 免听申请
import freeApplyIndex from "@/components/newPages/student/freeApply/index";
import freeApplyApply from "@/components/newPages/student/freeApply/apply";
// 请假
import holidayIndex from "@/components/newPages/student/holiday/index";
import holidayApply from "@/components/newPages/student/holiday/apply";
import holidayHistory from "@/components/newPages/student/holiday/history";
import holidayDel from "@/components/newPages/student/holiday/del";
// 复议申请
import fyApplyIndex from "@/components/newPages/student/fyApply/index";
import fyApplyResult from "@/components/newPages/student/fyApply/result";
// 批量缓考申请
import plhksqIndex from "@/components/newPages/student/plhksq/index";
import plhksqApply from "@/components/newPages/student/plhksq/apply";
import plhksqMyApply from "@/components/newPages/student/plhksq/myApply";
import plhksqDetail from "@/components/newPages/student/plhksq/detail";
// 毕业信息核对
import byxxhdIndex from "@/components/newPages/student/byxxhd/index";
import byxxhdSelectRz from "@/components/newPages/student/byxxhd/selectRz";
// 毕业信息核对
import jhrxxcjIndex from "@/components/newPages/student/jhrxxcj/index";

//即时评教
import evaluateOnTime from "@/components/student/Evaluate/evaluateOnTime";

//目标课程评价
import evaluateGoal from "@/components/student/Evaluate/evaluateGoal";

//学业进度查看
import xyjdck from "@/components/newPages/student/xyjdck/index";

//学籍异动申请
import xjydsq from "@/components/newPages/student/xjydsq/index";
import xjydsqDetail from "@/components/newPages/student/xjydsq/detail";

//学生信息修改申请
import xsxxxgsq from "@/components/newPages/student/xsxxxgsq/index";
import xsxxxgsqUpdate from "@/components/newPages/student/xsxxxgsq/update";
// 补考报名
import bkbm from "@/components/newPages/student/bkbm/index"
import cjdsq from "@/components/newPages/student/cjdsq/index"
import cjdsqBd from "@/components/newPages/student/cjdsq/sq"
import cxbm from "@/components/newPages/student/cxbm/index"


const newStudentRoute = [
  // 个人信息查看和修改
  {
    path: "/student/personInfo",
    name: "personInfo",
    url: 'personInfo',
    component: () => import("@/components/newPages/student/personInfo/index"),
  },
  // 学业进度查看
  {
    path: "/xyjdck/index",
    name: "xyjdck",
    url: 'xyjdck',
    component: xyjdck
  },
  // 学籍异动申请
  {
    path: "/xjydsq/index",
    name: "xjydsq",
    component: xjydsq
  },
  {
    path: "/xjydsq/detail",
    name: "xjydsqDetail",
    component: xjydsqDetail
  },
  // 学生信息修改申请
  {
    path: "/xsxxxgsq/index",
    name: "xsxxxgsq",
    component: xsxxxgsq
  },
  {
    path: "/xsxxxgsq/update",
    name: "xsxxxgsqUpdate",
    component: xsxxxgsqUpdate
  },
  // 毕业信息核对
  {
    path: "/jhrxxcj/index",
    name: "jhrxxcjIndex",
    component: jhrxxcjIndex
  },
  // 毕业信息核对
  {
    path: "/byxxhd/index",
    name: "byxxhdIndex",
    component: byxxhdIndex
  },
  {
    path: "/byxxhd/selectRz",
    name: "byxxhdSelectRz",
    component: byxxhdSelectRz
  },
  // 批量缓考申请
  {
    path: "/plhksq/index",
    name: "plhksqIndex",
    component: plhksqIndex
  },
  {
    path: "/plhksq/apply",
    name: "plhksqApply",
    component: plhksqApply
  },
  {
    path: "/plhksq/myApply",
    name: "plhksqMyApply",
    component: plhksqMyApply
  },
  {
    path: "/plhksq/detail",
    name: "plhksqDetail",
    component: plhksqDetail
  },
  // 复议申请
  {
    path: "/fyApply/index",
    name: "fyApplyIndex",
    component: fyApplyIndex
  },
  {
    path: "/fyApply/result",
    name: "fyApplyResult",
    component: fyApplyResult
  },
  // 请假
  {
    path: "/holiday/index",
    name: "holidayIndex",
    component: holidayIndex
  },
  {
    path: "/holiday/apply",
    name: "holidayApply",
    component: holidayApply
  },
  {
    path: "/holiday/history",
    name: "holidayHistory",
    component: holidayHistory
  },
  {
    path: "/holiday/del",
    name: "holidayDel",
    component: holidayDel
  },
  // 免听申请
  {
    path: "/freeApply/index",
    name: "freeApplyIndex",
    component: freeApplyIndex
  },
  {
    path: "/freeApply/apply",
    name: "freeApplyApply",
    component: freeApplyApply
  },
  // 查询申请
  {
    path: "/selectApply/index",
    name: "selectApplyIndex",
    component: selectApplyIndex
  },

  {
    path: "/selectApply/list",
    name: "selectApplyList",
    component: selectApplyList
  },
  {
    path: "/selectApply/apply",
    name: "selectApplyApply",
    component: selectApplyApply
  },
  // 实习任务
  {
    path: "/sxTask/index",
    name: "sxTask",
    component: sxTask
  },
  {
    path: "/sxTask/item",
    name: "sxTaskItem",
    component: sxTaskItem
  },
  // 实习考勤
  {
    path: "/sxKq/index",
    name: "sxKq",
    component: sxKq
  },
  {
    path: "/sxKq/KQ",
    name: "sxKqKQ",
    component: sxKqKQ
  },
  {
    path: "/sxKq/item",
    name: "sxKqItem",
    component: sxKqItem
  },
  {
    path: "/sxKq/daka",
    name: "sxKqDaka",
    component: sxKqDaka
  },
  {
    path: "/sxKq/time",
    name: "sxKqTime",
    component: sxKqTime
  },
  // 单独实习申请
  {
    path: "/sxAlone/index",
    name: "sxAlone",
    component: sxAlone
  },
  {
    path: "/sxAlone/apply",
    name: "sxAloneApply",
    component: sxAloneApply
  },
  // 实习异动
  {
    path: "/sxChange/index",
    name: "sxChange",
    component: sxChange
  },
  {
    path: "/sxChange/item",
    name: "sxChangeItem",
    component: sxChangeItem
  },
  {
    path: "/sxChange/apply",
    name: "sxChangeApply",
    component: sxChangeApply
  },
  // 北科学生评教
  {
    path: "/bk/xspj",
    name: "xspjIndex",
    component: xspjIndex
  },
  {
    path: "/bk/xspjItem",
    name: "xspjItem",
    component: xspjItem
  },
  {
    path: "/bk/pj",
    name: "xspjPJ",
    component: xspjPJ
  },
  // 学业完成情况
  {
    path: "/xywcqk/index",
    name: "xywcqkIndex",
    component: xywcqkIndex
  },
  // 创新学分查看
  {
    path: "/cxxf/index",
    name: "cxxfIndex",
    component: cxxfIndex
  },
  // 学生教室借用
  {
    path: "/roomBorrow/index",
    name: "roomBorrowIndex",
    component: roomBorrowIndex
  },
  // 空闲教室
  {
    path: "/restRooms/index",
    name: "borrowBar",
    component: borrowBar,
    redirect: "/kx_bindex",
    children: [
      {
        path: "/kx_bindex",
        name: "restRooms",
        component: restRooms
      },
      {
        path: "/student_bList",
        name: "borrowList",
        component: borrowList
      }
    ]
  },
  {
    path: "/restRooms/borrowRulst",
    name: "borrowRulst",
    component: borrowRulst
  },
  {
    path: "/restRooms/roomMore",
    name: "roomMore",
    component: roomMore
  },
  {
    path: "/restRooms/toBorrow",
    name: "toBorrow",
    component: toBorrow
  },
  // 南京林业空闲教室
  {
    path: "/njkxRooms/searTable",
    name: "njkx_table",
    component: njkxRooms
  },
  // 培养方案
  {
    path: "/train/index",
    name: "trainIndex",
    component: trainIndex
  },
  {
    path: "/train/item",
    name: "trainItem",
    component: trainItem
  },
  // 辅修报名
  {
    path: "/fxApply/index",
    name: "fxApplyIndex",
    component: fxApplyIndex
  },
  //学生过程评价
  {
    path: "/processEvaluation/index",
    name: "processEvaluationIndex",
    component: processEvaluationIndex,
    meta: {
      keepAlive: true
    }
  },
  //学生评价
  {
    path: "/studentEvaluation/index",
    name: "studentEvaluationIndex",
    component: studentEvaluationIndex
  },
  {
    path: "/student/evaluateOnTime",
    name: "evaluateOnTime",
    component: evaluateOnTime
  },
  {
    path: "/student/evaluateGoal",
    name: "evaluateGoal",
    component: evaluateGoal
  },
  //学生留言
  {
    path: "/dialogue/index",
    name: "dialogueIndex",
    component: dialogueIndex
  },
  // 重修报名
  {
    path: "/cxApply/index",
    name: "cxApplyIndex",
    component: cxApplyIndex
  },
  {
    path: "/cxApply/index_12959",
    name: "cxApplyIndex_12959",
    component: cxApplyIndex_12959
  },
  // 补考报名
  {
    path: "/bkApply/index",
    name: "bkApplyIndex",
    component: bkApplyIndex
  },
  // 教学课堂反馈
  {
    path: "/teachAdvice/index",
    name: "teachIndex",
    component: teachIndex
  },
  {
    path: "/teachAdvice/more",
    name: "teachMore",
    component: teachMore
  },
  {
    path: "/teachAdvice/content",
    name: "teachContent",
    component: teachContent
  },
  {
    path:'/bkbm/index',
    name:'bkbm',
    component:bkbm
  },
  {
    path:'/cjdsq/index',
    name:'cjdsq',
    component:cjdsq
  },
  {
    path:'/cjdsq/sq',
    name:'cjdsqBd',
    component:cjdsqBd
  },
  {
    path:'/cxbm/index',
    name:'cxbm',
    component:cxbm
  },
];
export default newStudentRoute;



// WEBPACK FOOTER //
// ./src/router/newStudent.js